<template>
    <div v-if="isShow" class="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
        <div class="bg-white p-6 rounded-lg shadow-lg  w-[70%] max-h-[80%] overflow-y-auto"
            :class="{ 'animate-popupFadeIn': isVisible, 'animate-popupFadeOut': !isVisible }">
            <!-- Popup content -->
            <h2 class="text-lg font-bold mb-4">{{ nameHeader }}</h2>
            <div class="grid grid-cols-2 gap-4 my-4">
                <div>
                    <div>Loại phiếu:</div>
                    <div class="grid grid-cols-2 gap-4">
                        <label class="flex items-center">
                            <input type="radio" value="1" v-model="Noteoption"
                                class="form-radio h-4 w-4 text-indigo-600 focus:ring-indigo-500" />
                            <span class="ml-2 text-sm text-gray-700">Phiếu thu</span>
                        </label>

                        <label class="flex items-center">
                            <input type="radio" value="2" v-model="Noteoption"
                                class="form-radio h-4 w-4 text-indigo-600 focus:ring-indigo-500" />
                            <span class="ml-2 text-sm text-gray-700">Phiếu chi</span>
                        </label>
                    </div>
                </div>
                <div>
                    <div class="relative inline-block w-full">
                        <!-- Label -->
                        <label for="select" class="block text-sm font-medium text-gray-700">Nhóm thu chi <span
                                class="text-red-500">*</span></label>

                        <!-- Select Dropdown -->
                        <select id="select" v-model="selectedOption"
                            class="h-8 w-[100%] border-b-[1px] focus:border-blue-500 focus:outline-none">
                            <option v-for="(option, index) in options" :key="index" :value="option">
                                {{ option }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-3 gap-4 my-4">
                <div>
                    <div>Chu kỳ nhận <span class="text-red-500">*</span></div>
                    <select id="select" v-model="selectCycleoption"
                        class="h-8 w-[100%] border-b-[1px] focus:border-blue-500 focus:outline-none">
                        <option v-for="(option, index) in Cycleoption" :key="index" :value="option">
                            {{ option }}
                        </option>
                    </select>
                </div>
                <div>
                    <div>SL Ngày <span class="text-red-500">*</span></div>
                    <input type="number" placeholder="Số lượng ngày"
                        class="h-8 w-[100%] border-b-[1px] focus:border-blue-500 focus:outline-none ">
                </div>
                <div>
                    <div>Ngày chu kỳ tiếp theo <span class="text-red-500">*</span></div>
                    <input type="datetime-local" placeholder="Số lượng này"
                        class="h-8 w-[100%] border-b-[1px] focus:border-blue-500 focus:outline-none ">
                </div>
            </div>
            <div class="my-4">
                <div>Thu bằng:</div>
                <div class="grid grid-cols-2 gap-4">
                    <label class="flex items-center">
                        <input type="radio" value="1" v-model="selectedOptionPayment"
                            class="form-radio h-4 w-4 text-indigo-600 focus:ring-indigo-500" />
                        <span class="ml-2 text-sm text-gray-700">Tiền mặt</span>
                    </label>

                    <label class="flex items-center">
                        <input type="radio" value="2" v-model="selectedOptionPayment"
                            class="form-radio h-4 w-4 text-indigo-600 focus:ring-indigo-500" />
                        <span class="ml-2 text-sm text-gray-700">Ngân hàng</span>
                    </label>
                </div>
                <div class="grid grid-cols-4 gap-4">
                    <div class="col-span-4"><input type="text" :value="formattedMoney" @input="updateMoney($event)"
                            @keypress="onlyNumber" placeholder="Nhập số tiền"
                            class="h-8 w-[100%] text-right text-[20px] font-bold my-4 border-b-[1px] focus:border-blue-500 focus:outline-none">
                            <p v-if="money" class="text-right"><i>{{ moneyInWords }}</i></p>
                        </div>
                </div>
            </div>
            <div>
                <textarea name="long-text" id="1" placeholder="Diễn giải"
                    class="w-[100%] p-2 border-2 border-gray-100 rounded-sm focus:border-blue-500 focus:outline-none"></textarea>
            </div>
            <div class="grid grid-cols-3 gap-4 my-4">
                <div>
                    <div>Đối tượng nộp <span class="text-red-500">*</span></div>
                    <select id="select" v-model="selectedOptionUser"
                        class="h-8 w-[100%] border-b-[1px] focus:border-blue-500 focus:outline-none">
                        <option v-for="(option, index) in optionsUser" :key="index" :value="option">
                            {{ option }}
                        </option>
                    </select>
                </div>
                <div>
                    <div>Tên người nộp <span class="text-red-500">*</span></div>
                    <input type="text" placeholder="Tên người nộp"
                        class="h-8 w-[100%] border-b-[1px] focus:border-blue-500 focus:outline-none ">
                </div>
                <div>
                    <div>SĐT người nộp <span class="text-red-500">*</span></div>
                    <input type="tel" placeholder="Số điện thoại người nộp"
                        class="h-8 w-[100%] border-b-[1px] focus:border-blue-500 focus:outline-none ">
                </div>
            </div>
            <div class="my-4">
                <div>Chế độ hiển thị:</div>
                <div class="grid grid-cols-2 gap-4">
                    <label class="flex items-center">
                        <input type="radio" value="1" v-model="selectedOptionpuplic"
                            class="form-radio h-4 w-4 text-indigo-600 focus:ring-indigo-500" />
                        <span class="ml-2 text-sm text-gray-700">Công khai</span>
                    </label>

                    <label class="flex items-center">
                        <input type="radio" value="2" v-model="selectedOptionpuplic"
                            class="form-radio h-4 w-4 text-indigo-600 focus:ring-indigo-500" />
                        <span class="ml-2 text-sm text-gray-700">Không công khai</span>
                    </label>
                </div>
            </div>
            <div class="my-4">
                <input type="checkbox" class="mr-1 my-2">Hạch toán và kết quả kinh doanh
            </div>
            <div class="my-4">
                <input type="checkbox" class="mr-1 my-2">Kích hoạt sử dụng
            </div>
            <div class="flex justify-center space-x-4">
                <button
                    class="w-[100px] py-2 text-white font-bold border-2 border-blue-700 rounded-md bg-blue-700 mr-1">Tạo
                    mới</button>
                <button @click="closePopup()"
                    class="w-[100px] py-2 font-bold rounded-md border-2 text-gray-500 ml-1">Đóng</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        nameHeader: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            Cycleoption: ["Ngày", "Tuần", "Tháng"],
            selectCycleoption: "Ngày",
            Noteoption: "1",
            selectedOptionpuplic: "1",
            selectedOptionPayment: "1",
            selectedOption: "Khác",
            selectedOptionUser: "Khác",
            options: ["Option 1", "Option 2", "Option 3", "Khác"],
            optionsUser: ["Nhân viên", "Nhà cung cấp", "khách hàng", "Khác"],
            isVisible: true,
            money: ''
        };
    },
    computed: {
        formattedMoney() {
            // Chuyển số thành định dạng tiền tệ
            return this.money
                ? new Intl.NumberFormat("vi-VN").format(this.money)
                : "";
        },
        moneyInWords() {
            return this.money ? this.convertToWords(this.money) + " đồng" : "";
        }
    },
    methods: {
        updateMoney(event) {
            let value = event.target.value;

            // Chặn nhập chữ: Chỉ giữ số (loại bỏ ký tự không phải số)
            let valuemoney = value.replace(/\D/g, "");

            // Cập nhật giá trị thực tế
            this.money = valuemoney;
        },
        onlyNumber(event) {
            // Chỉ cho phép nhập số (cấm nhập chữ và ký tự đặc biệt)
            if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
            }
        },
        closePopup() {
            this.isVisible = false
            setTimeout(() => {
                this.$emit('closed');
            }, 200);
        },
        getNowDateTime() {
            const now = new Date();
            this.nowDateTime = now.toISOString().slice(0, 16);
        },
        convertToWords(number) {
            const units = ["", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
            const teens = ["mười", "mười một", "mười hai", "mười ba", "mười bốn", "mười lăm", "mười sáu", "mười bảy", "mười tám", "mười chín"];
            const tens = ["", "", "hai mươi", "ba mươi", "bốn mươi", "năm mươi", "sáu mươi", "bảy mươi", "tám mươi", "chín mươi"];

            function convertThreeDigits(num) {
                let str = "";
                let hundreds = Math.floor(num / 100);
                let remainder = num % 100;

                if (hundreds > 0) str += units[hundreds] + " trăm ";
                if (remainder > 0) {
                    if (remainder < 10) str += "lẻ " + units[remainder];
                    else if (remainder < 20) str += teens[remainder - 10];
                    else str += tens[Math.floor(remainder / 10)] + (remainder % 10 !== 0 ? " " + units[remainder % 10] : "");
                }

                return str.trim();
            }

            if (number == 0) return "không";

            let numStr = parseInt(number).toString();
            let numGroups = [];
            while (numStr.length > 0) {
                numGroups.unshift(numStr.slice(-3));
                numStr = numStr.slice(0, -3);
            }

            let words = "";
            let scale = ["", "nghìn", "triệu", "tỷ"];
            numGroups.forEach((group, index) => {
                if (parseInt(group) !== 0) {
                    words += convertThreeDigits(parseInt(group)) + " " + scale[numGroups.length - 1 - index] + " ";
                }
            });

            return words.trim();
        }
    },
};
</script>

<style scoped>
@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>